/**
 * Field-level building blocks shared by every User Event Relay schema. The
 * identifier shapes are deliberately narrow: an opaque id must look like an id,
 * so free text (a title, a name, a health value) cannot hide inside one.
 *
 * There is no sequence number and no inbox epoch. The Relay stores nothing, so
 * there is no log to number and no lifetime to identify; a client catches up
 * from the producer's undelivered table instead (`undelivered.ts`).
 */
import { z } from "zod";
/** One logical publication. Reset offers derive it deterministically from the offer id. */
export const RelayEventId = z.uuid();
const OPAQUE_ID = /^[A-Za-z0-9._:-]{1,128}$/;
/** The domain row that changed, for example a notification or Reset offer id. */
export const RelayResourceId = z.string().regex(OPAQUE_ID);
export const RelayTimestamp = z.iso.datetime({ offset: true });
/** One socket on the member's inbox, minted by the Worker on accept. Meaningless outside that inbox. */
export const RelayConnectionId = z.uuid();
/**
 * Upper bound on a serialised snapshot. A notification is a title, a body, a
 * deep link and a small data bag; anything larger belongs behind a refetch.
 */
export const RELAY_MAX_SNAPSHOT_BYTES = 16_384;
//# sourceMappingURL=primitives.js.map